import React from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import UiIcon from "../ui/icons/uiIcon";

export const subPartIsDone = (relatedIem, activeQuoteIndex, cartItems = []) => {
  const {placeholderChanged, activeFeature, activeNotInVisualizerFeature, firstClick} = relatedIem;
  const selectedFeature = activeFeature || activeNotInVisualizerFeature;
  return cartItems.some(cartItem => {
    return (cartItem.partId === relatedIem.partId) && (cartItem.currentQuote === activeQuoteIndex) && !cartItem.cartFeature.dbFeature.autoAddToCart
  }) || (placeholderChanged && firstClick[activeQuoteIndex] && selectedFeature && !selectedFeature.partName.includes("laceholder"))
}

const SubPartDoneCheckMark = (props) => {

  const {placeholderChanged, activeFeature, activeNotInVisualizerFeature, firstClick, activeQuoteIndex, partId, cartItems} = props;

  const selected = subPartIsDone(
    {placeholderChanged, activeFeature, activeNotInVisualizerFeature, firstClick, partId},
    activeQuoteIndex,
    cartItems
  );

  if (!selected) {
    return null
  }

  return (
    <div className="selection-footer-list__item-done selection-footer-list__item-done--svg">
      <UiIcon icon="checkmark" color="white"/>
    </div>
  )
};

SubPartDoneCheckMark.propTypes = {
  relatedItem: PropTypes.object.isRequired,
}

const mapStateToProps = (store, ownProps) => {
  return {
    activeQuoteIndex: store.quotesState.activeQuoteIndex,
    activeFeature: ownProps.relatedItem.activeFeature,
    activeNotInVisualizerFeature: ownProps.relatedItem.activeNotInVisualizerFeature,
    firstClick: ownProps.relatedItem.firstClick,
    placeholderChanged: ownProps.relatedItem.placeholderChanged,
    partId: ownProps.relatedItem.partId,
    cartItems: store.cartState.cartItems,
    fabricatorData: store.fabricatorState
  };
};
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SubPartDoneCheckMark)
